import React from "react";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import {Button, Input, LoginBox, LoginContainer, Title} from "../../painelDeCancelamento/loginCancelamento/styles";

const LoginRecebiveis: React.FC = () => {
  const [password, setPassword] = React.useState('');
  const history = useHistory();

  const predefinedPassword = 'qFfazVb3q4lsn6F%';

  const handleLogin = () => {
    if (password === predefinedPassword) {
      history.push('/admin/detalhe-liquidacao-recebiveis')
    } else {
      toast.error("Senha incorreta!");
    }
  };

  return(
    <LoginContainer>
      <LoginBox>
        <Title>Login Detalhamento Liquidação - Recebíveis</Title>
        <Input
          type="password"
          placeholder="Insira a senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button onClick={handleLogin}>Entrar</Button>
      </LoginBox>
    </LoginContainer>
  )
}

export default LoginRecebiveis;
